import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import { TaskSelectionPage } from "./components/pages/task-selection";
import { OnboardingPage } from "./components/pages/onboarding";
import { RecordingPage } from "./components/pages/recording";
import { WelcomeScreen } from "./components/auth/WelcomeScreen";
import { AuthOnboarding } from "./components/auth/AuthOnboarding";
import { SplashScreen } from "./components/auth/SplashScreen";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AuthProvider } from "./auth/AuthContext";
import { TaskProvider } from "./providers/task-provider";
import { SubmissionProvider } from "./providers/submission-provider";
import { ConditionalNavbar } from "./components/molecules/conditional-navbar";
import { HistoryPage } from "./components/pages/history";
import { AuthScreen } from "./components/auth/AuthScreen";
import { AddDemography } from "./components/pages/add-demography";
import { PaymentHistory } from "./components/pages/payment-history";
import { PayoutProvider } from "./providers/payout-provider";
import { Instructions } from "./components/pages/instructions";
import { QueryParamsProvider } from "./providers/query-params-provider";
import { DemographiesProvider } from "./providers/demographies-provider";
import { UserProvider } from "./providers/user-provider";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <AuthProvider>
      <TaskProvider>
        <SubmissionProvider>
          <PayoutProvider>
            <Router>
              <QueryParamsProvider>
                <UserProvider>
                  <DemographiesProvider>
                    <div className="App">
                  <ConditionalNavbar />
                  <Routes>
                    <Route path="/signup" element={<AuthScreen />} />
                    <Route
                      path="/auth-onboarding"
                      element={<AuthOnboarding />}
                    />
                    <Route
                      path="/signup-internal"
                      element={<AuthScreen isInternal={true} />}
                    />
                    <Route path="/login" element={<AuthScreen />} />
                    <Route
                      path="/add-demography"
                      element={
                        <ProtectedRoute>
                          <AddDemography skippIfDataExists={true} />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/instructions"
                      element={
                        <ProtectedRoute>
                          <Instructions />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <TaskSelectionPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/onboarding"
                      element={
                        <ProtectedRoute>
                          <OnboardingPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/recording"
                      element={
                        <ProtectedRoute>
                          <RecordingPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/history"
                      element={
                        <ProtectedRoute>
                          <HistoryPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/payment-history"
                      element={
                        <ProtectedRoute>
                          <PaymentHistory />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="*"
                      element={
                        <div>
                          <h2>404 Not Found</h2>
                          <Link to="/signup">Go to Authentication</Link>
                        </div>
                      }
                    />
                  </Routes>
                </div>
              </DemographiesProvider>
                </UserProvider>
              </QueryParamsProvider>
            </Router>
          </PayoutProvider>
        </SubmissionProvider>
      </TaskProvider>
    </AuthProvider>
  );
}

export default App;
